import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyState } from '../reducers';

export const getFlowsSearchState = createSelector(getDragonflyState, (state) => state?.flowsSearch);

export const getTemplateProperties = createSelector(getFlowsSearchState, (state) => state?.templateProperties);

export const getPanelExpansion = createSelector(getFlowsSearchState, (state) => state?.panelExpanded);

export const getFlowName = createSelector(getFlowsSearchState, (state) => state?.flowName);

export const getContextValues = createSelector(getFlowsSearchState, (state) => state?.flowContextValues);

export const getContext = createSelector(getFlowsSearchState, (state) => state?.flowContext);

export const getActiveFlows = createSelector(getFlowsSearchState, (state) => state?.activeFlows);

export const getDeactivatedFlows = createSelector(getFlowsSearchState, (state) => state?.deactivatedFlows);

export const getSearchRole = createSelector(getRoles, (roles) => !roles?.['flow.action.search']);

export const getCreateNewRole = createSelector(getRoles, (roles) => !roles?.['flow.action.create']);

export const getUpdateRole = createSelector(getRoles, (roles) => !!roles?.['flow.action.update']);

export const getUpdateAdvancedRole = createSelector(getRoles, (roles) => !!roles?.['flow.action.updateadvanced']);
